import { render, staticRenderFns } from "./SteatMap.vue?vue&type=template&id=227796d7&scoped=true&"
import script from "./SteatMap.vue?vue&type=script&lang=js&"
export * from "./SteatMap.vue?vue&type=script&lang=js&"
import style0 from "./SteatMap.vue?vue&type=style&index=0&id=227796d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227796d7",
  null
  
)

export default component.exports